import { createContext, useContext } from 'react';

export const ReorderingContext = createContext(null);
export const useReorderingContext = () => {
    const context = useContext(ReorderingContext);
    return context;
};
